import { TagContract } from '@app-types/api/tag';
import {
  ContactType,
  ContactsSearchOrder,
  ContractEmailType,
  ImportContactState,
} from '@app-types/enums/contacts';
import { BaseIdListRequest, BaseIdsList } from '@app-types/base/base';
import { BaseGetRequest } from '@app-types/base/base-get.request';
import { FilterFields } from '@app-types/common';

export interface ContactEmail {
  contactEmailId?: number;
  contactId?: number;
  email: string;
  type: ContractEmailType;
  isDefault: boolean;
  createdDateTime?: string;
}

export interface ContactInfo {
  contactId?: number | null;
  mailAccountId: number | null;
  type: ContactType;
  alias?: string;
  firstName?: string;
  lastName?: string;
  companyName?: string;
  vatNumber?: string;
  vatCountry?: string;
  taxCode?: string;
  eoriCode?: string;
  emails: ContactEmail[];
  tags?: TagContract[];
  country?: string;
  city?: string;
  street?: string;
  region?: string;
  postalCode?: string;
  notes?: string;
  createdDateTime?: string;
  routingCode?: string;
  recipientCode?: string;
  transmissionFormat?: string;
  address?: string;
  defaultEmail?: string;
}

export class ContactGetRequest extends BaseGetRequest {
  id: number;
  mailAccountId: number | null;
  organizationId?: number;

  constructor(
    id: number,
    mailAccountId: number | null,
    organizationId?: number
  ) {
    super();
    this.id = id;
    this.mailAccountId = mailAccountId;
    this.organizationId = organizationId;
  }
}

export interface ContactExportRequest extends BaseIdsList {
  mailAccountId: number;
}

export interface ImportContactsUploadRequest {
  mailAccountId: number;
  file: File;
}

export interface ContactImportErrorContract {
  code: number;
  field?: string;
  message?: string;
}

export interface ContactImportResultRowContract {
  rowIdentifier: string;
  alias: string | null;
  email: string;
  isDuplicate: boolean;
  userId?: number;
  error: ContactImportErrorContract | null;
}

export interface ImportFileItem extends ContactImportResultRowContract {
  id: string;
  state: ImportContactState;
  fileName: string;
}

export interface DeleteContactRequest extends BaseIdListRequest {
  mailAccountId: number;
}

export interface FilterContacts extends FilterFields<ContactsSearchOrder> {
  tags: TagContract[];
}
